// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"676":"6c4cb33a","827":"b26829cf"}[chunkId] + ".chunk.css";
};